import React, { useEffect } from "react"; // Import the React library
import styles from "./TestingForm.module.css"; // Import the CSS module
import {
    AccountMenu,
    TwoSwitch,
    PageFoot,
    LoginOverlay,
    LoadingIndicator
} from "../../lib/iprs-react-library/src/index";

const PUBLIC_URL = process.env.PUBLIC_URL;

const TestingFormWrapper = ({ api }) => {
    const [loggedIn, setLoggedIn] = React.useState(null);

    const handleLoginEvent = action => {
        console.log(action);
        if (action === "Logged out") {
            api.logout();
            setLoggedIn(false);
            sessionStorage.removeItem("apiToken");
            localStorage.removeItem("Token");
            api.setToken(null);
        } else if (action === "Logged in") {
            setLoggedIn(true);
        }
    };

    // for pre-authenticated users with a token URL
    // other users will have to login
    useEffect(() => {
        // get the token from the URL (Token or token)
        const url = new URL(window.location.href);
        const token = url.searchParams.get("Token") || url.searchParams.get("token");
        if (token && !loggedIn) {
            api.validateLoggedIn(token)
            .then(r=> {
                api.setToken(token);
                setLoggedIn(true);
            })
            .catch(e=> {
                console.error(e);
                setLoggedIn(false);
            });
        }
    }, [api]);

    return (
        <div className="App">
            <div className="typography">
                <div className="container">
                    <main className="main">
                        <div className="container">
                            <header className="topHeader main__top">
                                <div className="main__top-logo">
                                    <img
                                        src={
                                            PUBLIC_URL +
                                            "/images/iprshealth.svg"
                                        }
                                        alt="IPRS Health"
                                    />
                                </div>
                                <h1 className="main__top-title">
                                    IPRS Health's Services
                                </h1>
                                <AccountMenu
                                    api={api}
                                    handleLoginEvent={handleLoginEvent}
                                />
                            </header>
                        </div>

                        <section className="main__section">
                            <TwoSwitch test={loggedIn}>
                                <TestingOrSubmissionResult api={api} />
                                <div className="container typography login_container">
                                    <main>
                                        <LoginOverlay
                                            handleLoginEvent={handleLoginEvent}
                                            api={api}
                                        />
                                    </main>
                                </div>
                            </TwoSwitch>
                        </section>
                    </main>
                </div>
            </div>

            <PageFoot />
        </div>
    );
};

const TestingOrSubmissionResult = ({ api }) => {
    const [request, setRequest] = React.useState(null);
    const [response, setResponse] = React.useState(null);

    const handleSubmitted = (request_, response_) => {
        setRequest(request_);
        setResponse(response_);
    };

    const handleClick = e => {
        e.preventDefault();
        setRequest(null);
        setResponse(null);
    };

    return (
        <>
            <TwoSwitch test={null !== request}>
                <div
                    style={{
                        textAlign: "left",
                        padding: "1em",
                        maxWidth: "50em",
                        overflowWrap: "break-word",
                        whiteSpace: "pre-wrap"
                    }}
                >
                    <h2>Result</h2>
                    <p>You have submitted this data to the API</p>
                    <pre>{JSON.stringify(request, null, "\t")}</pre>
                    <h2>Data</h2>
                    <p>This is what was received:</p>
                    <pre style={{ whiteSpace: "pre-wrap" }}>
                        {JSON.stringify(response, null, "\t")}
                    </pre>
                    <h2>Diary link</h2>
                    <p>
                        This is the link to which the patient would be
                        redirected by Wysa
                    </p>
                    <a target="none" href={response?.NextURL}>
                        Click here (opens in a new tab)
                    </a>
                    <br />
                    <button onClick={handleClick}>Submit another</button>
                </div>
                <TestingForm api={api} onSubmitted={handleSubmitted} />
            </TwoSwitch>
        </>
    );
};


const TestingForm = ({ api, onSubmitted }) => {
    const [patient, setPatient] = React.useState({
        Forename: "Forename",
        Surname: "Surname",
        DOB: "1970-01-01",
        Gender: "F",
        MembershipNumber: "123",
        AuthorityCode: "098",
        Email: "mail@example",
        PolicyRenewalDate: "2026-01-01",
        MobileTelNo: "0987654321",
        CoverType: "CoverType",
        Excess: 123.32,
        PlanType: "PlanType",
        ProductType: "EPH",
        StaffScheme: false,
        Bloomberg: false,
        Source: "Source",
        PatientHomeAddress: {
            Address1: "Address1",
            Address2: "Address2",
            Town: "Town",
            County: "County",
            Postcode: "Postcode",
            Country: "GB"
        }
    });
    const [clinicalAssessment, setClinicalAssessment] = React.useState({
        WysaAssessmentIdentifier: "WysaAssessmentIdentifier",
        AssessmentSummaryPlainText: "AssessmentSummaryPlainText",
        ConfirmedRisk: false,
        PrimaryProblemCategory: "PrimaryProblemCategory",
        GAD7: {
            GAD7Score: 28,
            GAD7Answer1: 1,
            GAD7Answer2: 2,
            GAD7Answer3: 3,
            GAD7Answer4: 4,
            GAD7Answer5: 5,
            GAD7Answer6: 6,
            GAD7Answer7: 7
        },
        PHQ9: {
            PHQ9Score: 45,
            PHQ9Answer1: 1,
            PHQ9Answer2: 2,
            PHQ9Answer3: 3,
            PHQ9Answer4: 4,
            PHQ9Answer5: 5,
            PHQ9Answer6: 6,
            PHQ9Answer7: 7,
            PHQ9Answer8: 8,
            PHQ9Answer9: 9
        },
        WSAS: {
            WSASScore: 15,
            WSASAnswer1: 1,
            WSASAnswer2: 2,
            WSASAnswer3: 3,
            WSASAnswer4: 4,
            WSASAnswer5: 5
        }
    });
    const [redirectToDiary, setRedirectToDiary] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handlePatientChange = e => {
        const { name, value, type, checked } = e.target;
        setPatient(prevPatient => ({
            ...prevPatient,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const handleClinicalAssessmentChange = e => {
        const { name, value, type, checked } = e.target;
        const [category, field] = name.split(".");
        setClinicalAssessment(prevClinicalAssessment => {
            if (!field) {
                return {
                    ...prevClinicalAssessment,
                    [name]: type === "checkbox" ? checked : value
                };
            } else {
                return {
                    ...prevClinicalAssessment,
                    [category]: {
                        ...prevClinicalAssessment[category],
                        [field]: type === "checkbox" ? checked : value
                    }
                };
            }
        });
    };

    const handleSubmit = e => {
        e.preventDefault();
        setLoading(true);
        api.transact("SaveReferralNew", {
            Patient: patient,
            ClinicalData: clinicalAssessment
        })
            .then(r => {
                if (redirectToDiary) {
                    const diaryURL = r.apiResult.NextURL;
                    window.open(diaryURL, "_blank");
                }
                setError(null);
                onSubmitted(r.requestParams, r.apiResult);
            })
            .catch(e => setError(e.message))
            .finally(() => setLoading(false));
    };

    return (
        <form className={styles.testingForm} onSubmit={handleSubmit}>
            <h1>Testing Form</h1>
            <fieldset>
                <legend>Automatically Redirect</legend>
                <div className={styles.fieldContainer}>
                    <label htmlFor="redirect" className={styles.label}>Automatically redirect to the diary on submit</label>
                    <input
                        type="checkbox"
                        name="redirect"
                        id="redirect"
                        checked={redirectToDiary || false}
                        onChange={e => setRedirectToDiary(e.target.checked)}
                    />
                </div>
            </fieldset>
            <fieldset>
                <legend>Patient</legend>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Forename</label>
                    <input
                        type="text"
                        name="Forename"
                        value={patient.Forename || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Surname</label>
                    <input
                        type="text"
                        name="Surname"
                        value={patient.Surname || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>DOB</label>
                    <input
                        type="date"
                        name="DOB"
                        value={patient.DOB || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Gender</label>
                    <input
                        type="text"
                        name="Gender"
                        value={patient.Gender || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>MembershipNumber</label>
                    <input
                        type="text"
                        name="MembershipNumber"
                        value={patient.MembershipNumber || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>AuthorityCode</label>
                    <input
                        type="text"
                        name="AuthorityCode"
                        value={patient.AuthorityCode || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Email</label>
                    <input
                        type="email"
                        name="Email"
                        value={patient.Email || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>PolicyRenewalDate</label>
                    <input
                        type="date"
                        name="PolicyRenewalDate"
                        value={patient.PolicyRenewalDate || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>MobileTelNo</label>
                    <input
                        type="text"
                        name="MobileTelNo"
                        value={patient.MobileTelNo || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>CoverType</label>
                    <input
                        type="text"
                        name="CoverType"
                        value={patient.CoverType || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Excess</label>
                    <input
                        type="number"
                        name="Excess"
                        value={patient.Excess || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>PlanType</label>
                    <input
                        type="text"
                        name="PlanType"
                        value={patient.PlanType || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>ProductType</label>
                    <input
                        type="text"
                        name="ProductType"
                        value={patient.ProductType || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>StaffScheme</label>
                    <input
                        type="checkbox"
                        name="StaffScheme"
                        checked={patient.StaffScheme || false}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Bloomberg</label>
                    <input
                        type="checkbox"
                        name="Bloomberg"
                        checked={patient.Bloomberg || false}
                        onChange={handlePatientChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>Source</label>
                    <input
                        type="text"
                        name="Source"
                        value={patient.Source || ""}
                        onChange={handlePatientChange}
                    />
                </div>
                <fieldset>
                    <legend>PatientHomeAddress</legend>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Address1</label>
                        <input
                            type="text"
                            name="Address1"
                            value={
                                patient.PatientHomeAddress.Address1 || ""
                            }
                            onChange={handlePatientChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Address2</label>
                        <input
                            type="text"
                            name="Address2"
                            value={
                                patient.PatientHomeAddress.Address2 || ""
                            }
                            onChange={handlePatientChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Town</label>
                        <input
                            type="text"
                            name="Town"
                            value={patient.PatientHomeAddress.Town || ""}
                            onChange={handlePatientChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>County</label>
                        <input
                            type="text"
                            name="County"
                            value={
                                patient.PatientHomeAddress.County || ""
                            }
                            onChange={handlePatientChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Postcode</label>
                        <input
                            type="text"
                            name="Postcode"
                            value={
                                patient.PatientHomeAddress.Postcode || ""
                            }
                            onChange={handlePatientChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Country</label>
                        <input
                            type="text"
                            name="Country"
                            value={
                                patient.PatientHomeAddress.Country || ""
                            }
                            onChange={handlePatientChange}
                        />
                    </div>
                    </fieldset>
            </fieldset>
            <fieldset>
                <legend>Clinical Assessment</legend>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>
                        WysaAssessmentIdentifier
                    </label>
                    <input
                        type="text"
                        name="WysaAssessmentIdentifier"
                        value={
                            clinicalAssessment.WysaAssessmentIdentifier || ""
                        }
                        onChange={handleClinicalAssessmentChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>
                        AssessmentSummaryPlainText
                    </label>
                    <input
                        type="text"
                        name="AssessmentSummaryPlainText"
                        value={
                            clinicalAssessment.AssessmentSummaryPlainText || ""
                        }
                        onChange={handleClinicalAssessmentChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>ConfirmedRisk</label>
                    <input
                        type="checkbox"
                        name="ConfirmedRisk"
                        checked={clinicalAssessment.ConfirmedRisk || false}
                        onChange={handleClinicalAssessmentChange}
                    />
                </div>
                <div className={styles.fieldContainer}>
                    <label className={styles.label}>
                        PrimaryProblemCategory
                    </label>
                    <input
                        type="text"
                        name="PrimaryProblemCategory"
                        value={clinicalAssessment.PrimaryProblemCategory || ""}
                        onChange={handleClinicalAssessmentChange}
                    />
                </div>
                <fieldset>
                    <legend>GAD7</legend>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Score</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Score"
                            value={clinicalAssessment.GAD7.GAD7Score || ""}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer1</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer1"
                            value={clinicalAssessment.GAD7.GAD7Answer1}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer2</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer2"
                            value={clinicalAssessment.GAD7.GAD7Answer2}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer3</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer3"
                            value={clinicalAssessment.GAD7.GAD7Answer3}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer4</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer4"
                            value={clinicalAssessment.GAD7.GAD7Answer4}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer5</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer5"
                            value={clinicalAssessment.GAD7.GAD7Answer5}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer6</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer6"
                            value={clinicalAssessment.GAD7.GAD7Answer6}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer7</label>
                        <input
                            type="number"
                            name="GAD7.GAD7Answer7"
                            value={clinicalAssessment.GAD7.GAD7Answer7}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                </fieldset>
                <fieldset>
                    <legend>PHQ9</legend>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Score</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Score"
                            value={clinicalAssessment.PHQ9.PHQ9Score || ""}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 1</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer1"
                            value={clinicalAssessment.PHQ9.PHQ9Answer1}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 2</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer2"
                            value={clinicalAssessment.PHQ9.PHQ9Answer2}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 3</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer3"
                            value={clinicalAssessment.PHQ9.PHQ9Answer3}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 4</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer4"
                            value={clinicalAssessment.PHQ9.PHQ9Answer4}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 5</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer5"
                            value={clinicalAssessment.PHQ9.PHQ9Answer5}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 6</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer6"
                            value={clinicalAssessment.PHQ9.PHQ9Answer6}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 7</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer7"
                            value={clinicalAssessment.PHQ9.PHQ9Answer7}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 8</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer8"
                            value={clinicalAssessment.PHQ9.PHQ9Answer8}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 9</label>
                        <input
                            type="number"
                            name="PHQ9.PHQ9Answer9"
                            value={clinicalAssessment.PHQ9.PHQ9Answer9}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                </fieldset>
                <fieldset>
                    <legend>WSAS</legend>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Score</label>
                        <input
                            type="number"
                            name="WSAS.WSASScore"
                            value={clinicalAssessment.WSAS.WSASScore || ""}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 1</label>
                        <input
                            type="number"
                            name="WSAS.WSASAnswer1"
                            value={clinicalAssessment.WSAS.WSASAnswer1}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 2</label>
                        <input
                            type="number"
                            name="WSAS.WSASAnswer2"
                            value={clinicalAssessment.WSAS.WSASAnswer2}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 3</label>
                        <input
                            type="number"
                            name="WSAS.WSASAnswer3"
                            value={clinicalAssessment.WSAS.WSASAnswer3}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 4</label>
                        <input
                            type="number"
                            name="WSAS.WSASAnswer4"
                            value={clinicalAssessment.WSAS.WSASAnswer4}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                    <div className={styles.fieldContainer}>
                        <label className={styles.label}>Answer 5</label>
                        <input
                            type="number"
                            name="WSAS.WSASAnswer5"
                            value={clinicalAssessment.WSAS.WSASAnswer5}
                            onChange={handleClinicalAssessmentChange}
                        />
                    </div>
                </fieldset>
            </fieldset>
            <button type="submit" className={styles.button}>
                Submit
            </button>
            <LoadingIndicator loading={loading} />
            {error && <div className={styles.error}>{error}</div>}
        </form>
    );
};

export default TestingFormWrapper;
